// import React from 'react';
//
// import css from './TitleMenuMenu.module.css';
// import {useTranslation} from "react-i18next";
// import {getTitleMenuMenu} from "../../../helpers";
// import {NavLink} from "react-router-dom";
//
//
// const TitleMenuMenu = () => {
//     const {t} = useTranslation();
//     const listTitleMenu = getTitleMenuMenu(t);
//
//
//     return (
//         <nav className={css.wrap}>
//             <ul className={css.ul}>
//                 {listTitleMenu.map(({name, linkForRoute}) => (
//                     <li key={name}>
//                         <NavLink
//                             to={`/menu/${linkForRoute.toLowerCase()}`}
//                             className={({isActive}) =>
//                                 `${css.menuItem} ${isActive ? css.active : ''}`
//                             }
//                         >
//                             <span className={css.menuText}>{name}</span>
//                         </NavLink>
//                     </li>
//                 ))}
//             </ul>
//         </nav>
//     );
// };
//
// export {TitleMenuMenu};







import React from 'react';

import css from './TitleMenuMenu.module.css';
import {useTranslation} from "react-i18next";
import {getTitleMenuMenu} from "../../../helpers";
import {NavLink} from "react-router-dom";


const TitleMenuMenu = () => {
    const {t} = useTranslation();
    const listTitleMenu = getTitleMenuMenu(t);


    return (
        <nav className={css.wrap}>
            <ul className={css.ul}>
                {listTitleMenu.map(({name, linkForRoute}) => (
                    <li key={name}>
                        <NavLink
                            to={`/menu/${linkForRoute.toLowerCase()}`}
                            className={({isActive}) =>
                                `${css.menuItem} ${isActive ? css.active : ''}`
                            }
                        >
                            <span className={css.menuText}>{name}</span>
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export {TitleMenuMenu};